<template>
  <portalHeader></portalHeader>
  <router-view />
  <portalFooter></portalFooter>
</template>

<script>
import portalHeader from "./components/portalHeader.vue";
import portalFooter from "./components/portalFooter.vue";

export default {
  name: "App",
  components: {
    portalHeader,
    portalFooter,
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@100;300;400;500;700;900&display=swap");
* {
  font-family: "Noto Sans JP", sans-serif;
}
</style>
